import {useState, useEffect} from 'react'

const useFetch = (url) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isPending, setIsPending] = useState(true);

    useEffect(() => {
        const AbortCtrl = new AbortController();        
        fetch(url, {signal: AbortCtrl.signal})
            .then(result => {
                if (!result.ok) {
                    throw Error(`Unexpected response from server for [${url}]`);
                }                      
                return result.json();
            })
            .then(content => {
                setData(content);
                setIsPending(false);
                setError(null);
            })
            .catch(err => {
                if (err.name === "AbortError") {
                    console.log("fetching data was aborted...");
                }
                else {
                    setIsPending(false);
                    setError(`ERROR: [${err.message}]`);
                }
            });
                        
            return () => { AbortCtrl.abort()}

    }, [url]);

    return {data, isPending, error}
}


export default useFetch;